import PropTypes from 'prop-types';
import React from 'react';
import Reactable from 'reactable';
import classnames from 'classnames';
import Percentage from '../../../../common/Percentage';
import { getColumns } from '../constants';
import * as shapes from '../shapes';

const Tr = Reactable.Tr;
const Td = Reactable.Td;
const Item = ({ item, onClick }) => {
  const columns = getColumns();
  return (
    <Tr
      className="c-table__tr c-table__tr--clickable"
      onClick={onClick(item.id)}
      key={item.id}
    >
      { columns.map((column, idx) => {
      const Component = column.type === 'percentage' ? Percentage : 'span';
      let value = item[column.key];
      if (column.valueFormat) {
        value = column.valueFormat(value);
      }
      return (
        <Td
          className={classnames({ 'no-pointer-events': !item.id || item.isDefaultLead, 'u-text-left': idx !== 0 })}
          column={column.key}
          value={value}
          key={column.key}
        >
          {<Component>{item[column.key]}</Component>}
        </Td>
      );
    })}
    </Tr>
  );
};
Item.propTypes = {
  item: shapes.item.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Item;
